<template>
  <div v-if="!isError">
    <div v-if="!isLoading">
      <div class="dashboard-content">
        <div class="preview-header d-flex justify-content-between align-items-center">
          <div class="preview-header-info">
            <h5 class="mb-3">{{ $t('feeds.field_preview') }}</h5>
            <p class="mb-1">{{$t('feeds.preview_description')}}</p>
          </div>
          <div class="d-flex feed-preview-buttons" v-if="$route.name.includes('edit')">
            <router-link :to="{ name: 'feed.edit.tagging', params: { id: $route.params.projectId, feedId: feed.id, feed: feed }}" class="feed-preview-back">
              <button class="btn btn-large btn-gray-dark">
                <arrow-left-circle-icon></arrow-left-circle-icon>
                <span>{{ $t('feeds.tag_return') }}</span>
              </button>
            </router-link>
            <button @click="saveFeed" class="btn btn-large btn-orange-dark feed-preview-save">
              <save-icon></save-icon>
              <span>{{ $t('feeds.save_feed') }}</span>
            </button>
          </div>
          <div class="d-flex feed-preview-buttons" v-else>
            <router-link :to="{ name: 'feed.create.tagging', params: { id: $route.params.projectId, feed: feed }}" class="feed-preview-back">
              <button class="btn btn-large btn-gray-dark">
                <arrow-left-circle-icon></arrow-left-circle-icon>
                <span>{{ $t('feeds.tag_return') }}</span>
              </button>
            </router-link>
            <button @click="saveFeed" class="btn btn-large btn-orange-dark feed-preview-save">
              <save-icon></save-icon>
              <span>{{ $t('feeds.save_feed') }}</span>
            </button>
          </div>
        </div>
        <div class="preview-body">
          <table class="table table-striped table-bordered table-feed-final">
            <div>
              <thead class="thead-light">
                <th v-for="(value, key) in feed.config.mappingRules" v-bind:key="key">
                  <div class="d-flex justify-content-center align-items-center">
                    <div>{{ value.to }}</div>
                  </div>
                </th>
              </thead>
              <tbody>
                <tr v-for="(product, index) in feedData" v-bind:key="index">
                  <td v-for="(value, column) in feed.config.mappingRules" v-bind:key="column">
                    <p class="break-text">{{ product[value.to] }}</p>
                  </td>
                </tr>
              </tbody>
            </div>
          </table>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="spinner-border text-orange" role="status"></div>
    </div>
  </div>
  <div v-else>
    <div class="alert alert-danger mb-4 mt-3" role="alert">
      {{ $t('feeds.feed_save_error') }}
    </div>
    <router-link :to="{ name: 'feed.create.main-settings', params: { projectId: $route.params.projectId, feed: { name: '' } }}" class="mr-2">
      <button type="button" class="btn btn-large btn-orange-dark">
        <plus-circle-icon></plus-circle-icon>
        <span>{{ $t('global.try_again') }}</span>
      </button>
    </router-link>
  </div>
</template>

<script>
import { ArrowLeftCircleIcon, PlusCircleIcon, SaveIcon } from 'vue-feather-icons'
import axios from 'axios'

export default {
  name: 'Preview',

  data () {
    return {
      feedResultType: '',
      isError: false,
      isLoading: false
    }
  },

  props: {
    feed: { required: true, type: Object },
    feedData: { required: true, type: Array }
  },

  created () {
    if (this.feed.config.resultType === undefined) this.feedResultType = this.feed.type.resultType
    else this.feedResultType = this.feed.config.resultType
  },

  methods: {
    saveFeed () {
      this.isLoading = true
      if (this.$route.name.includes('edit')) {
        axios.post(process.env.VUE_APP_API_ENDPOINT + '/data/feeds/update/' + this.$route.params.projectId + '/' + this.feed.id, this.finalFeedConfig)
          .then((response) => {
            this.isLoading = false
            if ((response.status === 201) || (response.status === 200)) {
              this.$router.push({ name: 'feed.edit.finish', params: { projectId: this.$route.params.projectId, feed: this.feed, feedId: response.data.id, products: this.feedData } })
            }
          })
          .catch(() => {
            this.isError = true
          })
      } else {
        axios.post(process.env.VUE_APP_API_ENDPOINT + '/data/feeds/add/' + this.$route.params.projectId, this.finalFeedConfig)
          .then((response) => {
            this.isLoading = false
            if ((response.status === 201) || (response.status === 200)) {
              this.$attrs.project.feeds.push(response.data)
              this.$router.push({ name: 'feed.create.finish', params: { projectId: this.$route.params.projectId, feed: this.feed, feedId: response.data.id, products: this.feedData } })
            }
          })
          .catch(() => {
            this.isError = true
          })
      }
    }
  },

  computed: {
    finalFeedConfig () {
      return {
        name: this.feed.name,
        active: this.feed.active,
        config: {
          resultType: this.feedResultType,
          formatRules: this.feed.config.formatRules.map(function (formatRule) {
            return {
              conditions: formatRule.conditions.map(function (condition) {
                return {
                  columnName: condition.columnName,
                  conditionType: condition.conditionType,
                  conditionString: condition.conditionString
                }
              }),
              columnName: formatRule.columnName,
              operationType: formatRule.operationType,
              toReplace: formatRule.toReplace,
              replaceWith: formatRule.replaceWith
            }
          }),
          mappingRules: this.feed.config.mappingRules.map(function (mappingRule) {
            return { from: mappingRule.from, to: mappingRule.to }
          }),
          filterRules: this.feed.config.filterRules.map(function (filterRule) {
            return {
              conditions: filterRule.conditions.map(function (condition) {
                let columnName = ''
                if (condition.filteringField !== null && condition.filteringField !== undefined) columnName = condition.filteringField.value
                let conditionType = ''
                if (condition.filteringType !== null && condition.filteringType !== undefined) conditionType = condition.filteringType.value
                return {
                  columnName: columnName,
                  conditionType: conditionType,
                  conditionString: condition.conditionString
                }
              })
            }
          }),
          taggingRules: this.feed.config.taggingRules.map(function (taggingRule) {
            return { tag: taggingRule.tag, value: taggingRule.value, isDynamic: taggingRule.isDynamic }
          })
        },
        feedType: this.feed.feedType
      }
    }
  },

  components: { ArrowLeftCircleIcon, PlusCircleIcon, SaveIcon }

}
</script>
